import { createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "working-schedule-box mt-25" }
const _hoisted_2 = { class: "letter-spacing" }
const _hoisted_3 = { class: "info-list ps-0 mb-0 list-unstyled mt-10" }
const _hoisted_4 = { class: "d-inline-block p-0 border-0" }
const _hoisted_5 = { class: "d-flex align-items-center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "d-block w-10 h-10 bg-primary rounded-circle me-8" }, null, -1 /* HOISTED */)
const _hoisted_7 = { class: "fw-bold" }
const _hoisted_8 = { class: "text-muted fw-semibold text-uppercase small" }
const _hoisted_9 = { class: "d-inline-block p-0 border-0" }
const _hoisted_10 = { class: "d-flex align-items-center" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "d-block w-10 h-10 bg-success rounded-circle me-8" }, null, -1 /* HOISTED */)
const _hoisted_12 = { class: "fw-bold" }
const _hoisted_13 = { class: "text-muted fw-semibold text-uppercase small" }
const _hoisted_14 = { class: "d-inline-block p-0 border-0" }
const _hoisted_15 = { class: "d-flex align-items-center" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "d-block w-10 h-10 bg-warning rounded-circle me-8" }, null, -1 /* HOISTED */)
const _hoisted_17 = { class: "fw-bold" }
const _hoisted_18 = { class: "text-muted fw-semibold text-uppercase small" }
const _hoisted_19 = { class: "d-inline-block p-0 border-0" }
const _hoisted_20 = { class: "d-flex align-items-center" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "d-block w-10 h-10 bg-danger rounded-circle me-8" }, null, -1 /* HOISTED */)
const _hoisted_22 = { class: "fw-bold" }
const _hoisted_23 = { class: "text-muted fw-semibold text-uppercase small" }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { class: "row mt-10" }
const _hoisted_26 = { class: "col-4" }
const _hoisted_27 = { class: "d-flex flex-column gap-3 h-100 justify-content-end" }
const _hoisted_28 = { class: "fw-bold text-primary text-badge d-inline-block" }
const _hoisted_29 = { class: "text-muted fw-normal text-uppercase small" }
const _hoisted_30 = { class: "fw-bold text-success text-badge d-inline-block" }
const _hoisted_31 = { class: "text-muted fw-normal text-uppercase small" }
const _hoisted_32 = { class: "fw-bold text-warning text-badge d-inline-block" }
const _hoisted_33 = { class: "text-muted fw-normal text-uppercase small" }
const _hoisted_34 = { class: "fw-bold text-danger text-badge d-inline-block" }
const _hoisted_35 = { class: "text-muted fw-normal text-uppercase small" }
const _hoisted_36 = { class: "col-8" }
const _hoisted_37 = { class: "schedule-list mt-15 mt-md-20" }
const _hoisted_38 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_39 = { class: "content" }
const _hoisted_40 = { class: "d-flex align-items-center mb-5" }
const _hoisted_41 = { class: "fw-bold mb-1" }
const _hoisted_42 = { class: "d-block text-black fw-semibold" }
const _hoisted_43 = {
  key: 0,
  class: "ms-2 small"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VDatePicker = _resolveComponent("VDatePicker")!
  const _component_DayIntakeStatsChart = _resolveComponent("DayIntakeStatsChart")!
  const _component_SpinnerLoading = _resolveComponent("SpinnerLoading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createCommentVNode(" <div class=\"card mb-25 border-0 rounded-0 bg-white working-schedule-box\"> "),
    _createElementVNode("div", _hoisted_1, [
      _createCommentVNode(" <div class=\"card-body p-15 p-sm-20 p-sm-25 p-lg-30 letter-spacing\"> "),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_VDatePicker, {
          modelValue: _ctx.date,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.date) = $event)),
          class: "therapy-calendar",
          view: "weekly",
          locale: _ctx.$i18n.locale,
          onDayclick: _ctx.loadData
        }, null, 8 /* PROPS */, ["modelValue", "locale", "onDayclick"]),
        _createElementVNode("ul", _hoisted_3, [
          _createElementVNode("li", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("span", _hoisted_7, [
                _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t(`feature.therapy.intake.$status.${_ctx.status.waiting}`)), 1 /* TEXT */)
              ])
            ])
          ]),
          _createElementVNode("li", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("span", _hoisted_12, [
                _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t(`feature.therapy.intake.$status.${_ctx.status.taken_in_time}`)), 1 /* TEXT */)
              ])
            ])
          ]),
          _createElementVNode("li", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _createElementVNode("span", _hoisted_17, [
                _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t(`feature.therapy.intake.$status.${_ctx.status.taken_not_in_time}`)), 1 /* TEXT */)
              ])
            ])
          ]),
          _createElementVNode("li", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _hoisted_21,
              _createElementVNode("span", _hoisted_22, [
                _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$t(`feature.therapy.intake.$status.${_ctx.status.not_taken}`)), 1 /* TEXT */)
              ])
            ])
          ])
        ]),
        (_ctx.dayStats && _ctx.intakes?.length !== 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("span", _hoisted_28, [
                      _createTextVNode(_toDisplayString(_ctx.dayStats.waiting_response) + " ", 1 /* TEXT */),
                      _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.$t(`feature.therapy.intake.$status.${_ctx.status.waiting}`)), 1 /* TEXT */)
                    ]),
                    _createElementVNode("span", _hoisted_30, [
                      _createTextVNode(_toDisplayString(_ctx.dayStats.taken_in_time) + " ", 1 /* TEXT */),
                      _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.$t(`feature.therapy.intake.$status.${_ctx.status.taken_in_time}`)), 1 /* TEXT */)
                    ]),
                    _createElementVNode("span", _hoisted_32, [
                      _createTextVNode(_toDisplayString(_ctx.dayStats.taken_not_in_time) + " ", 1 /* TEXT */),
                      _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.$t(`feature.therapy.intake.$status.${_ctx.status.taken_not_in_time}`)), 1 /* TEXT */)
                    ]),
                    _createElementVNode("span", _hoisted_34, [
                      _createTextVNode(_toDisplayString(_ctx.dayStats.not_taken) + " ", 1 /* TEXT */),
                      _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.$t(`feature.therapy.intake.$status.${_ctx.status.not_taken}`)), 1 /* TEXT */)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_36, [
                  _createVNode(_component_DayIntakeStatsChart, { stats: _ctx.dayStats }, null, 8 /* PROPS */, ["stats"])
                ])
              ])
            ]))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_37, [
          (_ctx.intakes === undefined)
            ? (_openBlock(), _createBlock(_component_SpinnerLoading, {
                key: 0,
                class: "mt-50"
              }))
            : (_ctx.intakes?.length === 0)
              ? (_openBlock(), _createElementBlock("p", _hoisted_38, _toDisplayString(_ctx.$t('feature.therapy.no_therapy_scheduled_today')), 1 /* TEXT */))
              : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.intakes, (intake) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: intake.id,
                    class: _normalizeClass(["list-item pt-15 pb-15 pt-md-20 pb-md-20 ps-20 pe-15 position-relative d-sm-flex justify-content-between align-items-center", intake.status === _ctx.status.waiting ? 'bg-f2f1f9' : intake.status === _ctx.status.taken_in_time ? 'bg-ecf3f2' : intake.status === _ctx.status.taken_not_in_time ? 'bg-f9faf7' : 'bg-faf7f7'])
                  }, [
                    _createElementVNode("div", _hoisted_39, [
                      _createElementVNode("div", _hoisted_40, [
                        _createElementVNode("h6", _hoisted_41, _toDisplayString(_ctx.intakeTime(intake.time)), 1 /* TEXT */)
                      ]),
                      _createElementVNode("span", _hoisted_42, [
                        _createTextVNode(_toDisplayString(intake?.drug ?? '') + " ", 1 /* TEXT */),
                        (_ctx.env === 'kareena')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_43, _toDisplayString(_ctx.getTherapy(intake.therapy_id)?.dose ?? ''), 1 /* TEXT */))
                          : _createCommentVNode("v-if", true)
                      ])
                    ])
                  ], 2 /* CLASS */))
                }), 128 /* KEYED_FRAGMENT */))
        ])
      ])
    ])
  ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
}